// Data that configures the Player Possession Table
import { possessionTeamTableRowItems } from '@/utils/dataTablesStructures/team';
import baseColumns from '@/data/team/baseColumns';

export default {
  columns: baseColumns,
  expandedRows: possessionTeamTableRowItems.reduce((accumulator, item) => {
    if (!item.categoryIds) {
      accumulator.push(item.category);
    }
    return accumulator;
  }, []),
};
